import { IRespuesta, IRespuestaPaginada } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';

import { negocioConfiguracion } from '../../conexiones';
import IDocumentoConDetalleCompuesto from '../documentosDetalle/entidades/documentoConDetalleCompuesto';
import IDocumentoConDetallesAccion from '../documentosDetalle/entidades/documentoConDetallesAccion';
import IDocumentoDetalle from '../documentosDetalle/entidades/documentoDetalle';
import IDocumento from './entidades/documento';
import IDocumentoAuditoria from './entidades/documentoAuditoria';
import IDocumentoCompuesto from './entidades/documentoCompuesto';
import IDocumentoCompuestoMovimiento from './entidades/documentoCompuestoMovimiento';
import IDocumentoConDetalle from './entidades/documentoConDetalle';
import IDocumentoConsulta from './entidades/documentoConsulta';
import IDocumentoPadreCompuesto from './entidades/documentoPadreCompuesto';
import IFiltroGeneralDocumentoConsulta from './entidades/filtroGeneralDocumentoConsulta';
import IFiltroGeneralDocumentosPaginador from './entidades/filtroGeneralDocumentosPaginador';
import IFiltrosDocumento from './entidades/filtrosDocumento';
import IFiltrosDocumentoPadre from './entidades/filtrosDocumentoPadre';
import IFiltrosDocumentos from './entidades/filtrosDocumentosMovimientos';
import IParametrosPaginador from './entidades/parametrosDocumentoMovimiento';

export default class ModeloDocumento {
    public consultaListaDocumentosCompuestaPadrePorFiltro(filtroDocumento: IFiltrosDocumentoPadre) {
        return manejadorRest<IRespuesta<IDocumentoPadreCompuesto>>(
            () => negocioConfiguracion.post('Documentos/ConsultarListaDocumentosCompuestaPadre', filtroDocumento),
            true
        );
    }

    public consultaListaDocumentosPorFiltro(filtroDocumento: IFiltrosDocumento) {
        return manejadorRest<IRespuesta<IDocumentoCompuesto>>(
            () => negocioConfiguracion.post('Documentos/ConsultarDocumentosCompuestaFiltro', filtroDocumento),
            true
        );
    }

    public consultaGeneralDocumentosFiltro(filtroDocumento: IFiltroGeneralDocumentoConsulta) {
        return manejadorRest<IRespuesta<IDocumentoConsulta>>(
            () => negocioConfiguracion.post('Documentos/ConsultaGeneralDocumentosFiltro', filtroDocumento),
            true
        );
    }

    public consultaDocumentosReversibles(filtroDocumento: IFiltroGeneralDocumentosPaginador) {
        return manejadorRest<IRespuestaPaginada<IDocumentoConsulta>>(
            () => negocioConfiguracion.post('Reversiones/ConsultaDocumentosReversibles', filtroDocumento),
            true
        );
    }

    public consultaDocumentosDevoluciones(filtroDocumento: IFiltroGeneralDocumentosPaginador) {
        return manejadorRest<IRespuestaPaginada<IDocumentoConsulta>>(
            () => negocioConfiguracion.post('Devoluciones/ConsultaDocumentosDevoluciones', filtroDocumento),
            true
        );
    }

    public consultarDespachosDevoluciones(EmpresaId: string) {
        return manejadorRest<IRespuestaPaginada<IDocumentoConsulta>>(
            () => negocioConfiguracion.post('Devoluciones/ConsultarDespachosDevoluciones', { EmpresaId }),
            true
        );
    }

    public crearDocumentoDevoluciones(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.post('Devoluciones/CrearDocumentoDevoluciones', documento),
            true
        );
    }

    public modificarDocumentoDetallesDevoluciones(documento: IDocumentoConDetallesAccion) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.put('Devoluciones/ModificarDocumentoDetallesDevoluciones', documento),
            true
        );
    }

    public cambiarEtapaDevolucion(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.put('Devoluciones/CambiarEtapaDevolucion', documento),
            true
        );
    }

    public consultarListaDocumentosAuditoriaCompuestos(parametros: IParametrosPaginador) {
        return manejadorRest<IRespuestaPaginada<IDocumentoCompuestoMovimiento>>(
            () => negocioConfiguracion.post('GestionDocumentosAuditoria/ConsultarListaDocumentosAuditoriaCompuesto', parametros),
            true
        );
    }

    public consultarDocumentosMovimientoEntradas(parametros: IParametrosPaginador) {
        return manejadorRest<IRespuestaPaginada<IDocumentoCompuestoMovimiento>>(
            () => negocioConfiguracion.post('GestionDocumentosMovimiento/ConsultarDocumentosMovimientoEntradas', parametros),
            true
        );
    }

    public consultaListaDocumentosDespachosPaginados(parametros: IParametrosPaginador) {
        return manejadorRest<IRespuestaPaginada<IDocumentoCompuestoMovimiento>>(
            () => negocioConfiguracion.post('DocumentosDespachos/ConsultaListaDocumentosDespachosPaginados', parametros),
            true
        );
    }

    public consultaListaDocumentosEnZonaDespachoPorFiltro(Documento: IFiltrosDocumentos) {
        return manejadorRest<IRespuestaPaginada<IDocumentoCompuestoMovimiento>>(
            () => negocioConfiguracion.post('DocumentosDespachos/ConsultaListaDocumentosEnZonaDespachoPorFiltro', Documento),
            true
        );
    }

    public crearDocumentosDetallesRecepcion(documentoDetalle: IDocumentoConDetalleCompuesto) {
        return manejadorRest<IRespuesta<IDocumentoConDetalleCompuesto>>(
            () => negocioConfiguracion.post('Documentos/GuardarDocumentosDetallesRecepcion', documentoDetalle),
            true
        );
    }

    public guardarDocumentoConDetalle(documentoConDetalle: IDocumentoConDetalle) {
        return manejadorRest<IRespuesta<IDocumentoConDetalle>>(
            () => negocioConfiguracion.post('Documentos/GuardarDocumentosDetallesCompuesto', documentoConDetalle),
            true
        );
    }

    public guardarDocumentosDetallesCompras(documentoDetalles: IDocumentoDetalle) {
        return manejadorRest<IRespuesta<IDocumentoDetalle>>(
            () => negocioConfiguracion.post('DocumentosCompras/GuardarDocumentosDetallesCompras', documentoDetalles),
            true
        );
    }

    public crearDocumentoAuditoria(documentoAuditoria: IDocumentoAuditoria) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.post('GestionDocumentosAuditoria/CrearDocumentoAuditoria', documentoAuditoria),
            true
        );
    }

    public crearDocumentoDetallesPedidos(documentoPedido: IDocumentoConDetallesAccion) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.post('DocumentosPedidos/GuardarDocumentoDetallesPedidos', documentoPedido),
            true
        );
    }

    public crearDocumentoDetallesDespachos(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.post('DocumentosDespachos/CrearDocumentoDespacho', documento),
            true
        );
    }

    public modificarEstadoAuditoria(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.put('GestionDocumentosAuditoria/ModificarEstadoAuditoria', documento),
            true
        );
    }

    public modificarEstadoEntrada(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.post('Entrada/CambiarEtapaEntrada', documento),
            true
        );
    }

    public modificarEstadoSalida(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(() => negocioConfiguracion.post('Salida/CambiarEtapaSalida', documento), true);
    }

    public modificarEstadoPedido(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.put('DocumentosPedidos/ModificarEstadoPedido', documento),
            true
        );
    }

    public modificarEstadoDespacho(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.put('DocumentosDespachos/ModificarEstadoDespacho', documento),
            true
        );
    }

    public revertirDocumento(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.post('Reversiones/RevertirDocumento', documento),
            true
        );
    }

    public anularDocumentoAuditoria(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.put('GestionDocumentosAuditoria/AnularDocumento', documento),
            true
        );
    }

    public anularDocumentoDespachos(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.put('DocumentosDespachos/AnularDocumentoDespacho', documento),
            true
        );
    }

    public cambiarEtapaDevolucionProveedor(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.post('DevolucionProveedor/CambiarEtapaDevolucionProveedor', documento),
            true
        );
    }

    public guardarDocumentoDevolucionProveedor(documentoConDetalle: IDocumentoConDetalle) {
        return manejadorRest<IRespuesta<IDocumentoConDetalle>>(
            () => negocioConfiguracion.post('DevolucionProveedor/GuardarDocumentoDevolucionProveedor', documentoConDetalle),
            true
        );
    }

    public editarDevolucionProveedor(documentoConDetalle: IDocumentoConDetalle) {
        return manejadorRest<IRespuesta<IDocumentoConDetalle>>(
            () => negocioConfiguracion.post('DevolucionProveedor/EditarDevolucionProveedor', documentoConDetalle),
            true
        );
    }

    public anularDevolucionProveedor(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(
            () => negocioConfiguracion.post('DevolucionProveedor/AnularDevolucionProveedor', documento),
            true
        );
    }

    public consultarListaDocumentosCompuestos(parametros: IParametrosPaginador) {
        return manejadorRest<IRespuestaPaginada<IDocumentoCompuestoMovimiento>>(
            () => negocioConfiguracion.post('GestionDocumentosMovimiento/ConsultarListaDocumentosCompuestos', parametros),
            true
        );
    }

    public editarDocumento(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumento>>(() => negocioConfiguracion.put('Documentos/EditarDocumentos', documento), true);
    }

    public anularDocumento(documento: IDocumento) {
        return manejadorRest<IRespuesta<IDocumentoConDetalle>>(
            () => negocioConfiguracion.post('Documentos/AnularDocumento', documento),
            true
        );
    }
}
